import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ClockOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.2c-5.412 0-9.8 4.388-9.8 9.8 0 5.412 4.388 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8 0-5.412-4.388-9.8-9.8-9.8ZM3.8 12a8.2 8.2 0 1 1 16.401.001A8.2 8.2 0 0 1 3.8 12Zm9-5.39a.8.8 0 0 0-1.6 0v5.17a.8.8 0 0 0 .3.624l3.32 2.66a.8.8 0 1 0 1-1.248l-3.02-2.42V6.61Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ClockOutlined
